import React, { useState, useEffect } from 'react';
import {
    Row, Col, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText,
    Button
} from 'reactstrap';
import { getPayment, savePayment, getPaymentTypes } from '../../API';
import AccountSelect from '../Account/AccountSelect';
import { validateString, store, getInputDate, blurCurrency, addMinutesToDateTime } from '../../Helper';

function PaymentEdit(props) {
    const [Payment, setPayment] = useState(null);

    const [isLoadingPayment, setIsLoadingPayment] = useState(true);
    const [isLoadingAccount, setIsLoadingAccount] = useState(true);
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [isLoadingDivisions, setIsLoadingDivisions] = useState(true);
    const [PaymentType, SetPaymentType] = useState(false);
    var PayID;

    useEffect(() => {
        fetchPayment();
        fetchPaymentTypes();
    }, []);


    const fetchPayment = async () => {
        setIsLoadingPayment(true);

        const paymentResult = await getPayment(props.match.params.paymentId)
        setPayment(paymentResult);


        setIsLoadingPayment(false);
        PayID = Payment.paymentType.paymentTypeID
    };

    const fetchPaymentTypes = async () => {
        setPaymentTypes(await getPaymentTypes());
    };

    const updatePayment = e => {
        let value = e.target.value;
        switch (e.target.type) {
            case "number":
                value = e.target.valueAsNumber;
                break;
            case "date":
                value = new Date(e.target.value);
                break;
        }

        setPayment({
            ...Payment,
            [e.target.name]: value
        });

    }



    const cancel = () => {
        console.log('Canceling...');
        props.history.goBack();
    };

    const save = async () => {
        if (await savePayment(Payment))
            props.history.goBack();
    };



    let PaymentJSX = (<div>No Payment Found...</div>);
    if (isLoadingPayment) {
        PaymentJSX = (<div>Loading...</div>);
    } else if (Payment) {
        PaymentJSX = (
            <div className="item-editables">
                {console.log(Object.entries(Payment)) }
                <Row xs={1} md={2} lg={3} xl={4}>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-users"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input type="select" name="paymentTypeID" value={PayID}>
                                    {paymentTypes.map(pt => (<option key={pt.paymentTypeID} value={pt}>{pt.paymentTypeName}</option>))}
                                </Input>
                                
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-dollar-sign"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input type="number" placeholder="PaymentAmount" name="paymentAmount" value={Payment.paymentAmount} onChange={updatePayment} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="far fa-calendar-alt"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input type="date" placeholder="Paid Date" name="paidDate" value={getInputDate(Payment.paidDate)} onChange={updatePayment} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
                <Row xs={1} md={2} lg={3} xl={4}>
                    <Col className="col" md={{ span: 6 }} lg={{ span: 4, offset: 4 }} xl={{ span: 3, offset: 6 }}>
                        <Button className="btn-block btn-icon" color="danr-red" onClick={cancel}><i className="fas fa-ban"></i><span>Cancel</span></Button>
                    </Col>
                    <Col className="col" md={{ span: 6 }} lg={{ span: 4 }} xl={{ span: 3 }}>
                        <Button className="btn-block btn-icon" color="danr-green" onClick={save}><i className="fas fa-save"></i><span>Save</span></Button>
                    </Col>
                </Row>
            </div>

            
        );
    }

    return (
        <div>
            <Row className="title-row">
                <Col>
                    <h1>Edit Payment</h1>
                </Col>
            </Row>
            <Row className="edit-row">
                <Col>
                    {PaymentJSX}
                </Col>
            </Row>
            
        </div>
    );
}

export default PaymentEdit;